/** Календарные даты ГГГГ-ММ-ДД без сдвига часового пояса. */

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/

export function parseIsoDate(iso: string): Date {
  const match = ISO_DATE.exec(iso)
  if (!match) {
    throw new Error("Дата должна быть в формате ГГГГ-ММ-ДД")
  }
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(Date.UTC(year, month - 1, day))
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    throw new Error("Некорректная дата")
  }
  return date
}

export function formatIsoDate(date: Date): string {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, "0")
  const day = String(date.getUTCDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export function formatRuDate(iso: string): string {
  parseIsoDate(iso)
  const [year, month, day] = iso.split("-")
  return `${day}.${month}.${year}`
}

export function todayIso(now: Date = new Date()): string {
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, "0")
  const day = String(now.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export function addDaysIso(iso: string, days: number): string {
  const date = parseIsoDate(iso)
  date.setUTCDate(date.getUTCDate() + days)
  return formatIsoDate(date)
}

export function compareIso(left: string, right: string): number {
  if (left === right) return 0
  return left < right ? -1 : 1
}

/** Обе границы входят в период, как DateTime::diff()->days + 1 в PHP. */
export function daysInclusive(from: string, to: string): number {
  const start = parseIsoDate(from).getTime()
  const end = parseIsoDate(to).getTime()
  return Math.round((end - start) / 86_400_000) + 1
}

export function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

export function daysInYearOf(iso: string): number {
  const year = Number(iso.slice(0, 4))
  return isLeapYear(year) ? 366 : 365
}

/**
 * PHP round($value, $digits) / PHP_ROUND_HALF_UP для положительных сумм:
 * половина уходит от нуля. Для денег калькулятора знак всегда положительный.
 */
export function roundHalfUp(value: number, digits: number): number {
  if (!Number.isFinite(value)) {
    throw new Error("Некорректное число")
  }
  const factor = 10 ** digits
  const scaled = value * factor
  const sign = scaled < 0 ? -1 : 1
  const rounded = Math.floor(Math.abs(scaled) + 0.5)
  return (sign * rounded) / factor
}
